/* AUTO-SYNCED from PsyKit.io/lib/utils.ts — DO NOT EDIT. Regenerate with `npm run sync`. */
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
